import { createApi } from '@reduxjs/toolkit/query/react';
import DealService from 'Services/DealService';

import axiosBaseQuery from 'utils/axios/axiosBaseQuery';

export default createApi({
  reducerPath: 'dealApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    get: build.query({
      queryFn: async (id, { signal }) => {
        return {
          data: await DealService.getDeal(id, { signal }),
        };
      },
      providesTags: ['DealGet'],
    }),
  }),
});
